import { Component } from '@angular/core';

@Component({
    selector: 'app-element-header',
    templateUrl: './element-header.component.html',
    styleUrls: ['./element-header.component.scss'],
})
export class ElementHeaderComponent {}
